import script from "./ProcEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcEditPage.vue?vue&type=script&setup=true&lang=js"

import "./ProcEditPage.vue?vue&type=style&index=0&id=a990f4e4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a990f4e4"]])

export default __exports__